import { serverAddr } from "../networkConfig";
import axios from "axios";

export default {
    getUserGroups(payload) {
		return serverAddr.post("users/user_groups/read/", payload);
	},
	getDepartment(storeID) {
		return serverAddr.post("/read/store-departments/", storeID);
	},
	getFunctions(storeID) {
		return serverAddr.post("read/store-functions/", storeID);
	},
	getStoreDesignation(params) {
		return serverAddr.post(`/store-designations/list/`, params);
	},
	getUserDesignation(params) {
		return serverAddr.get(`users/designations/list/?get_all=true`);
	},
	getUsers(params) {
		return serverAddr.get(`users/all_users/`);
	},
	getAllStoreData() {
		return serverAddr.get("outlet/?get_all=true");
	},
	getAllFilters(payload) {
		return axios.all([
			this.getDepartment(payload.dept),
			this.getFunctions(payload.function),
			this.getStoreDesignation(payload.deg),
			// this.getUserDesignation(payload.deg),
			this.getUsers(payload.users),
		]);
	},
	getUserGroupsSettings(payload) {
		return serverAddr.post(`users/user_group_guidelines/read/`, payload);
	},
	createGroup(payload) {
		return serverAddr.post(`users/user_groups/create-update/`, payload);
	},
	deleteGroup(payload) {
		return serverAddr.post(`users/user_groups/delete/`, payload);
	},
	createUpdateUserGroupSettings(payload) {
		return serverAddr.post(`users/user_group_guidelines/create-update/`, payload);
	},
	deleteGroupGuideline(payload) {
		return serverAddr.post(`users/user_group_guidelines/delete/`, payload);
	},
}